/**
 * OAuth 콜백 페이지
 * - Google OAuth 리다이렉트 후 토큰 처리
 */
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { toast } from '../components/ui/Toast';

const AuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const handleCallback = async () => {
      // URL 쿼리 파라미터에서 토큰만 추출 (user 파라미터는 보안상 무시)
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        console.error('OAuth 에러:', error);
        toast({
          title: '로그인 실패',
          description: 'Google 로그인 중 오류가 발생했습니다.',
          variant: 'destructive',
        });
        navigate('/login');
        return;
      }

      if (!token) {
        toast({
          title: '로그인 실패',
          description: '인증 정보를 가져올 수 없습니다.',
          variant: 'destructive',
        });
        navigate('/login');
        return;
      }

      // authStore action 경유로 토큰 저장 (localStorage + 스토어 동기화)
      useAuthStore.getState().setToken(token);

      try {
        // 서버에서 사용자 정보 조회 (token으로 인증)
        await useAuthStore.getState().refreshUser();

        const user = useAuthStore.getState().user;

        toast({
          title: 'Google 로그인 성공',
          description: `환영합니다, ${user?.name}님!`,
          variant: 'default',
        });

        navigate('/albums');
      } catch (profileError) {
        console.error('프로필 조회 실패:', profileError);

        // 프로필 조회 실패 시 토큰 정리 후 로그인 페이지로
        useAuthStore.getState().clearToken();

        toast({
          title: '로그인 실패',
          description: '인증 처리 중 오류가 발생했습니다.',
          variant: 'destructive',
        });
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">로그인 처리 중...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;

